"use strict";
exports.__esModule = true;
exports.RuleRequestType = exports.FactType = exports.Entity = exports.RuleCategory = exports.RuleCompareOperator = exports.AttributeDatatype = void 0;
var AttributeDatatype;
(function (AttributeDatatype) {
    AttributeDatatype["String"] = "string";
    AttributeDatatype["Number"] = "number";
    AttributeDatatype["Boolean"] = "boolean";
    AttributeDatatype["Datetime"] = "datetime";
    AttributeDatatype["Array"] = "array";
})(AttributeDatatype = exports.AttributeDatatype || (exports.AttributeDatatype = {}));
var RuleCompareOperator;
(function (RuleCompareOperator) {
    RuleCompareOperator["EQUALS"] = "EQUALS";
    RuleCompareOperator["NOT_EQUALS"] = "NOT_EQUALS";
    RuleCompareOperator["INCLUDE"] = "INCLUDE";
    RuleCompareOperator["EXCLUDE"] = "EXCLUDE";
    RuleCompareOperator["LESS_THAN"] = "LESS_THAN";
    RuleCompareOperator["LESS_THAN_OR_EQUALS"] = "LESS_THAN_OR_EQUALS";
    RuleCompareOperator["GREATER_THAN"] = "GREATER_THAN";
    RuleCompareOperator["GREATER_THAN_OR_EQUALS"] = "GREATER_THAN_OR_EQUALS";
    RuleCompareOperator["IN"] = "IN";
    RuleCompareOperator["IN_RANGE"] = "IN_RANGE";
    RuleCompareOperator["ARRAY_INTERSECTION_HAS_ONE"] = "ARRAY_INTERSECTION_HAS_ONE";
    RuleCompareOperator["ARRAY_INTERSECTION_HAS_ALL"] = "ARRAY_INTERSECTION_HAS_ALL";
})(RuleCompareOperator = exports.RuleCompareOperator || (exports.RuleCompareOperator = {}));
var RuleCategory;
(function (RuleCategory) {
    RuleCategory[RuleCategory["FleetRouter"] = 0] = "FleetRouter";
    RuleCategory[RuleCategory["Alert"] = 1] = "Alert";
    RuleCategory[RuleCategory["Rate"] = 2] = "Rate";
    RuleCategory[RuleCategory["Workflow"] = 3] = "Workflow";
})(RuleCategory = exports.RuleCategory || (exports.RuleCategory = {}));
var Entity;
(function (Entity) {
    Entity["Fleet"] = "fleet";
    Entity["DeliveryProvider"] = "delivery_provider";
    Entity["Action"] = "action";
})(Entity = exports.Entity || (exports.Entity = {}));
var FactType;
(function (FactType) {
    FactType["Task"] = "task";
    FactType["Waypoint"] = "waypoint";
    FactType["Run"] = "run";
    FactType["Rate"] = "rate";
    FactType["User"] = "user";
    FactType["DeliveryBlock"] = "delivery_block";
})(FactType = exports.FactType || (exports.FactType = {}));
var RuleRequestType;
(function (RuleRequestType) {
    RuleRequestType["Evaluate"] = "rule:evaluate";
})(RuleRequestType = exports.RuleRequestType || (exports.RuleRequestType = {}));
//# sourceMappingURL=rule_types.js.map